import Vue from 'vue'
import Home from './views/Home'
import Login from './views/Login'
import Register from './views/Register'
import StudentRegister from './views/StudentRegister'
import EditStudentRegister from './views/EditStudentRegister'
import Inbox from './views/Inbox'
import Profile from './views/Profile'
import Berkas from './views/Berkas'
import CetakData from './views/CetakData'
import Informasi from './views/Informasi'
import InformasiDetail from './views/InformasiDetail'
import JurusanDetail from './views/JurusanDetail'
import EmailVerification from './views/EmailVerification'
import ForgotPassword from './views/ForgotPassword'
import ResetPassword from './views/ResetPassword'
// import Dapodik from './views/Dapodik'

import auth from './middlewares/auth';
import emailVerified from './middlewares/email-verified';
import notVerified from './middlewares/not-verified';
import notAuth from './middlewares/not-auth';
import hasRegister from './middlewares/has-register';
import closedWave from './middlewares/closed-wave';
// import dapodik from './middlewares/dapodik';
import editForm from './middlewares/edit-form';
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const router = new VueRouter({
    mode: 'history',
    scrollBehavior() {
        return {
            x: 0,
            y: 0
        }
    },
    routes: [{
            path: '/',
            name: 'home',
            component: Home
        },
        {
            path: '/informasi',
            name: 'informasi',
            component: Informasi,
        },
        {
            path: '/informasi/:info',
            name: 'informasiDetail',
            props: { newsletterPopup: false },
            component: InformasiDetail,
        },
        {
            path: '/informasi/jurusan/:major',
            name: 'JurusanDetail',
            props: { newsletterPopup: false },
            component: JurusanDetail,
        },
        {
            path: '/masuk',
            name: 'login',
            component: Login,
            meta: {
                middleware: notAuth
            }
        },
        {
            path: '/daftar',
            name: 'register',
            component: Register,
            meta: {
                middleware: notAuth
            }
        },
        {
            path: '/daftar/:major',
            name: 'studentRegister',
            component: StudentRegister,
            meta: {
                middleware: [auth, hasRegister, notVerified, closedWave]
            }
        },
        {
            path: '/edit',
            name: 'editStudentRegister',
            component: EditStudentRegister,
            meta: {
                middleware: [auth, editForm]
            }
        },
        {
            path: '/berkas',
            name: 'berkas',
            component: Berkas,
            meta: {
                middleware: [auth, notVerified]
            }
        },
        {
            path: '/cetak-data',
            name: 'cetakData',
            component: CetakData,
            meta: {
                middleware: [auth, notVerified]
            }
        },
        {
            path: '/kotak-masuk',
            name: 'inbox',
            component: Inbox,
            meta: {
                middleware: [auth, notVerified]
            }
        },
        {
            path: '/profil-saya',
            name: 'profile',
            component: Profile,
            meta: {
                middleware: auth
            }
        },
        {
            path: '/email-verify/:id',
            name: 'emailVerify',
            component: EmailVerification,
            meta: {
                middleware: [auth, emailVerified]
            }
        },
        {
            path: '/forgot-password/',
            name: 'forgotPassword',
            component: ForgotPassword,
            meta: {
                middleware: [notAuth]
            }
        },
        {
            path: '/password-reset/',
            name: 'resetPassword',
            component: ResetPassword,
            meta: {
                middleware: [notAuth]
            }
        },
        // {
        //     path: '/dapodik',
        //     name: 'dapodik',
        //     component: Dapodik,
        //     meta: {
        //         middleware: dapodik
        //     }
        // }
    ]
});



function nextFactory(context, middleware, index) {
    const subsequentMiddleware = middleware[index];
    if (!subsequentMiddleware) return context.next;
    return (...parameters) => {
        context.next(...parameters);
        const nextMiddleware = nextFactory(context, middleware, index + 1);
        subsequentMiddleware({
            ...context,
            next: nextMiddleware
        });
    };
}


router.beforeEach((to, from, next) => {
    if (to.meta.middleware) {
        const middleware = Array.isArray(to.meta.middleware) ?
            to.meta.middleware : [to.meta.middleware];

        const context = {
            from,
            next,
            router,
            to,
        };

        const nextMiddleware = nextFactory(context, middleware, 1);
        return middleware[0]({
            ...context,
            next: nextMiddleware
        });
    }
    return next();
});


export default router;